module.exports = __webpack_public_path__ + "static/media/White.2a464042.svg";